import { Injectable, Inject, InjectionToken } from '@angular/core';

export const API_STORAGE_PREFIX = new InjectionToken<string>('api-storage-prefix');

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storage: Storage;

  constructor(@Inject(API_STORAGE_PREFIX) private keyPrefix: string) {
    this.storage = localStorage;
  }
  /**
   * Clear the whole localstorage
   */
  clear(): void {
    this.storage.clear();
  }

  /**
   * remove single item from storage
   */
  removeItem(key: string): void {
    key = this.addPrefix(key);
    return this.storage.removeItem(key);
  }

  /**
   * Set Key in storage and check if is in storage and override if override: true
   */
  setItem(key: string, item: any, override: boolean = true) {
    key = this.addPrefix(key);
    if (!this.storage.getItem(key)) {
      const data = typeof item !== 'string' ? JSON.stringify(item) : item;
      this.storage.setItem(key, data);
    } else if (this.storage.getItem(key) && override) {
      const data = typeof item !== 'string' ? JSON.stringify(item) : item;
      this.storage.setItem(key, data);
    }
  }

  /**
   * Get item from localstorage
   */
  getItem(key: string): any {
    key = this.addPrefix(key);
    const data = this.storage.getItem(key);

    if (data && (data.startsWith('{') || data.startsWith('['))) {
      return JSON.parse(data);
    }

    return data;
  }

  /**
   * get all keys stored in localstorage
   */
  keys(): string[] {
    const keys: string[] = [];

    for (let index = 0; index < this.storage.length; index++) {
      const key = this.removePrefix(this.storage.key(index));
      keys.push(key);
    }

    return keys;
  }

  /**
   * Get key by index
   */
  key(index: number): string {
    return this.removePrefix(this.storage.key(index));
  }

  /**
   * Get value by index
   */
  value(index: number): any {
    const key = this.removePrefix(this.storage.key(index));

    if (key) {
      return this.getItem(key);
    }

    return null;
  }

  /**
   * getter for length property
   */
  get length(): number {
    return this.storage.length;
  }

  /**
   * Adds the prefix to the given key
   * @param key Key
   */
  private addPrefix(key: string) {
    if (key == null || key.length === 0 || this.keyPrefix == null || this.keyPrefix.length === 0) {
      return key;
    }

    key = `${this.keyPrefix}${key}`;

    return key;
  }

  /**
   * Removes the prefix from the given key
   * @param key Key
   */
  private removePrefix(key: string) {
    if (key == null || key.length === 0 || this.keyPrefix == null || this.keyPrefix.length === 0) {
      return key;
    }

    if (key.startsWith(this.keyPrefix)) {
      key = key.substr(this.keyPrefix.length);
    }

    return key;
  }
}
